import {
  BrandConfig,
  PayAndPlayProvider,
  PayAndPlayProviderConfiguration,
  PayAndPlayProviderConfigurationBuilder,
} from '@whitehatgaming/shared';
import { register } from './register';
import { countries, translations } from './translations';

const pnpProviders: PayAndPlayProviderConfiguration[] = [
  new PayAndPlayProviderConfigurationBuilder(PayAndPlayProvider.zimplerGo, 'FI').build(),
];

export const brandConfig: BrandConfig = {
  id: 143,
  name: 'flaxino',
  displayName: 'Flaxino',
  path: 'flaxino',
  register: register,
  translations: {
    translations: translations,
    countries: countries,
  },
  supportEmail: 'support@flaxino.com',
  languages: ['en', 'de', 'fi', 'no', 'fr'],
  loqateKey: 'ZM92-PK69-DJ61-HE92',
  payNPlayProviders: pnpProviders,
  payNPlay: true,
  payNPlayCurrency: 'EUR',
  payNPlayContactCapture: {
    email: false,
    phone: false,
  },
  enableShowMarketingPreferencesOnHome: true,
  payNPlayDepositUrl: `${window.location.origin}/#quick-deposit-panel`,
  logoUrl: 'assets/header/flaxino-logo.svg',
  customization: {
    playPageConfig: {
      logoDisplayed: true,
    },
  },
  optimove: {
    optimoveSDKToken: '263f30681e6a4584a273b86d90060ea6',
    optimoveSDKVersion: '2.0',
    optimoveSDKconfigVersion: 'web-configuration.1.0.0',
  },
  routesRedirectedToLegacy: ['logout'],
};
